import { render, staticRenderFns } from "./approvalDetail.vue?vue&type=template&id=565c7e8a&scoped=true"
import script from "./approvalDetail.vue?vue&type=script&lang=js"
export * from "./approvalDetail.vue?vue&type=script&lang=js"
import style0 from "./approvalDetail.vue?vue&type=style&index=0&id=565c7e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565c7e8a",
  null
  
)

export default component.exports